import React, {useRef, useState} from 'react';
import Switch from "react-bootstrap-switch";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { connect } from 'react-redux'
import { Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';

import {
    ButtonCancel,
    ButtonEdit,
    ButtonNew,
    ButtonSubmit,
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import { FORM, REQUIRED } from "../../../components/i18n/i18n";
import {
    PH_CODE,
    PH_NAME
} from "../../../components/i18n/placeHolders";
import {
    FL_CODE,
    FL_NAME,
    FL_ORDER,
    FL_STATUS,
} from "../../../components/i18n/formLabels";

import { save, update } from "../../../redux/actions/hotel/ailrlineActions";
import { setViewMode } from "../../../redux/actions/generalActions/mainActions";
import {resetCombos, setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import {TT_HISTORY} from "../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";

const AirlineForm = props => {
    const fbDataBaseId = props.mainProps?.app?.fbDataBase?.id
    const { editMode, disableInputs, saveSuccess, domainObject } = props.formProps;
    const [status, setStatus] = useState(domainObject?.status || false);
    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        code: Yup.string().required( REQUIRED )
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            uid: domainObject?.uid,

            code: domainObject?.code,
            name: domainObject?.name,
            showOrder: domainObject?.showOrder
        }
    });

    const onSubmit = (data, _) => {
        const dataRequest = {
            fbDataBase:  { id : fbDataBaseId },
            item: {
                ...data,
                status: status,
            }
        }

        if (!editMode)
            return props.save(dataRequest);
        else {
            let id = domainObject.id;
            dataRequest.item.id = domainObject?.id

            return props.update(id, dataRequest)
        }
    };

    const resetForm = () => {
        props.setForm(false, false, false);
        setStatus(null);
        reset();
    }

    const beginEdit = () => {
        props.setForm(true, false, false);
    }

    const returnToList = () => {
        props.setViewMode("LIST");
        props.setItem(null);
        props.setForm();
    }

    return (
        <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="4">
                            <FormGroup>
                                <Label>{ FL_CODE }</Label>
                                <Input type="text" 
                                       name="code"
                                       placeholder={ PH_CODE }
                                       innerRef={register}
                                       disabled={disableInputs}
                                       className={(errors.code ? ' is-invalid' : '')}
                                />
                                { errors.code && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div>}
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>{ FL_NAME }</Label>
                                <Input type="text"
                                       name="name"
                                       placeholder={ PH_NAME }
                                       innerRef={register}
                                       disabled={disableInputs}
                                       className={(errors.name ? ' is-invalid' : '')}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>{ FL_ORDER }</Label>
                                <br/>
                                <Input type="number"
                                       name="showOrder"
                                       innerRef={register}
                                       disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="3">
                            <FormGroup>
                                <Label>{ FL_STATUS }</Label>
                                <br/>
                                <Switch animate={true} offText={"No"} onText={"Si"}
                                        value={status}
                                        disabled={disableInputs}
                                        onChange={_ => setStatus(!status)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <CardBody className="border-top">
                        {
                            saveSuccess ?
                                <div className="float-right">
                                    <ButtonNew onClick={ resetForm }/>
                                    <ButtonEdit onClick={ beginEdit }/>
                                    <ButtonCancel onClick={ returnToList }/>
                                </div>
                                : <div className="float-right">
                                    <ButtonSubmit/>
                                    <ButtonCancel onClick={ returnToList }/>
                                </div>
                        }
                    </CardBody>
                </Form>
            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ domainObject }
                />
            }
        </Card>
    )
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({
    setViewMode,
    resetCombos,
    setItem,
    setForm,
    save,
    update,
})

export default connect(mapStateToProps, mapActionsToProps)(AirlineForm)